import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Box,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { useParams } from "react-router-dom";
import CreatePigmyModal from "./CreatePigmyModal";
import {
  closePigmyService,
  getCustomerPigmysService,
} from "../../../../services/pigmyService";
import moment from "moment";
import useStore from "../../../../useStore";
import ReassignLoanModal from "../../../reassignLoan/reassignLoanModal";

function CustomerPigmy({ setTabValue }) {
  const { id } = useParams();
  const { setPigmyId, setLoanId } = useStore();
  const [pigmys, setPigmys] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const [userName, setUserName] = useState();
  const [openReassign, setOpenReassign] = useState(false);
  const [selectedLoanId, setSelectedLoanId] = useState(null);
  const [closeDialogOpen, setCloseDialogOpen] = useState(false);
  const [selectedPigmy, setSelectedPigmy] = useState(null);
  const [isClosing, setIsClosing] = useState(false);

  const handleOpenReassign = (loanId) => {
    setSelectedLoanId(loanId);
    setOpenReassign(true);
  };

  const getPigmy = async () => {
    const fetchPigmys = await getCustomerPigmysService(id);
    const customerPigmys = fetchPigmys?.data?.customerPigmys || [];
    setPigmys(customerPigmys);
    setLoanId(fetchPigmys?.data?.loanId);
    setUserName(fetchPigmys?.data?.userName);
    setIsDisabled(customerPigmys.some((pigmy) => pigmy.status === "Active"));

    // if (fetchPigmys.length > 0) {
    //   setIsDisabled(true);
    // } else {
    //   setIsDisabled(false);
    // }
    setPigmyId(customerPigmys[0]?._id);
  };
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleViewPigmy = (id) => {
    setPigmyId(id);
    setTabValue(3); // Navigates to "Loan Report" tab (Tab 3)
  };
  const handleOpenCloseDialog = (pigmy) => {
    setSelectedPigmy(pigmy);
    setCloseDialogOpen(true);
  };

  const handleCloseCloseDialog = () => {
    setCloseDialogOpen(false);
    setSelectedPigmy(null);
  };

  const handleClosePigmy = async () => {
    if (!selectedPigmy?._id) {
      return;
    }

    try {
      setIsClosing(true);
      await closePigmyService(selectedPigmy._id);
      handleCloseCloseDialog();
      await getPigmy();
    } catch (error) {
      alert(error);
    } finally {
      setIsClosing(false);
    }
  };

  useEffect(() => {
    getPigmy();
  }, []);

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          m: 1,
        }}
      >
        <Typography>
          <strong>Customer Name : </strong> {userName}
        </Typography>
        <Button
          variant="contained"
          size="small"
          disabled={isDisabled}
          sx={{
            py: 0.5,
            textTransform: "capitalize",
            fontSize: "16px",
            borderRadius: "8px",
          }}
          onClick={handleOpen}
        >
          Create Pigmy
        </Button>
        <CreatePigmyModal open={open} onClose={handleClose} id={id} />
      </Box>

      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="customer pigmy table">
          <TableHead>
            <TableRow>
              <TableCell>Agent Name</TableCell>
              <TableCell>Pigmy Code</TableCell>
              <TableCell>Pigmy Plan</TableCell>
              <TableCell>Collection Amount</TableCell>
              <TableCell>Frequency</TableCell>
              <TableCell>Total Remaining Amount</TableCell>
              <TableCell>Closure Date</TableCell>
              <TableCell>Start Date</TableCell>
              <TableCell>End Date</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {pigmys.map((row, index) => (
              <TableRow key={index}>
                <TableCell>{row.agentDetails?.userName}</TableCell>
                <TableCell>{row.pigmyCode}</TableCell>
                <TableCell>{row.pigmyPlan}</TableCell>
                <TableCell>{row.collectionAmount}</TableCell>
                <TableCell>{row.frequency}</TableCell>
                <TableCell>{row.totalSavings}</TableCell>

                <TableCell>{row.closureDate}</TableCell>

                <TableCell>
                  {" "}
                  {moment(row.startDate).format("DD-MM-YYYY")}
                </TableCell>
                <TableCell>
                  {" "}
                  {moment(row.endDate).format("DD-MM-YYYY")}
                </TableCell>
                <TableCell>{row.status}</TableCell>
                <TableCell>
                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    onClick={() => handleViewPigmy(row._id)}
                    sx={{ mr: 1 }}
                  >
                    View Pigmy
                  </Button>
                  {/* <Button variant="contained" color="primary" size="small">
                    Edit
                  </Button> */}
                  <Button
                    variant="contained"
                    color="secondary"
                    size="small"
                    onClick={() => handleOpenReassign(row._id)}
                    sx={{ mr: 1 }}
                  >
                    Reassign
                  </Button>
                  <Button
                    variant="contained"
                    color="error"
                    size="small"
                    disabled={row.status === "Closed"}
                    onClick={() => handleOpenCloseDialog(row)}
                  >
                    Close Pigmy
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <ReassignLoanModal
        open={openReassign}
        onClose={() => setOpenReassign(false)}
        loanId={selectedLoanId}
        type={"pigmy"}
      />
      <Dialog open={closeDialogOpen} onClose={handleCloseCloseDialog}>
        <DialogTitle>Close Pigmy</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to close this pigmy?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseCloseDialog} disabled={isClosing}>
            Cancel
          </Button>
          <Button
            onClick={handleClosePigmy}
            color="error"
            variant="contained"
            disabled={isClosing}
          >
            {isClosing ? "Closing..." : "Close Pigmy"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default CustomerPigmy;
